<div class="container-fluid p-4">
  <div *ngIf="isSelecting" class="text-center p-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2"><em>Loading association...</em></p>
  </div>

  <div *ngIf="!isSelecting">
    <div class="row">
      <div class="col-md-12">
        <h1>Select Association</h1>
        <p class="mb-4">Please select the association you want to view data for:</p>
      </div>
    </div>

    <div *ngIf="isLoading" class="text-center p-4">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2"><em>Loading associations...</em></p>
    </div>

    <div *ngIf="!isLoading && errorMessage" class="alert alert-danger">
      <h4>Error</h4>
      <p>{{ errorMessage }}</p>
      <p class="small text-muted mt-2">Check the browser console (F12) for detailed error information.</p>
    </div>


    <div *ngIf="!isLoading && !errorMessage && associations.length === 0" class="alert alert-warning">
      <h4>No Associations Found</h4>
      <p>No associations are available. Please ensure at least one association setting is configured in the system.</p>
    </div>

    <div *ngIf="!isLoading && !errorMessage && associations.length > 0" class="row">
      <div *ngFor="let association of associations" class="col-md-4 mb-3">
        <div class="card h-100 association-card" style="cursor: pointer;" (click)="selectAssociation(association.sourceId)">
          <div class="card-body">
            <h5 class="card-title">{{ association.name }}</h5>
            <p class="card-text text-muted">Source ID: {{ association.sourceId }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

